import React from "react";
import { WithStyles, withStyles, Grid, Typography } from "material-ui";
import { FormControlLabel } from "material-ui/Form";
import { InjectedFormProps, reduxForm } from "redux-form";

import ExtendedField from "../../../components/form/ExtendedField";
import renderTextField from "../../../components/form/RenderTextField";
import renderSelectField from "../../../components/form/RenderSelectField";
import renderCheckBox from "../../../components/form/RenderCheckBoxWithLabel";

import {
    AccountDto,
    WithdrawalRequestDto,
} from "../../../util/DTOs/AccountDtos";

import validate from "./validate/WithdrawalRequestFormValidator";
import {
    numericCommaStringFormatter,
    numericCommaStringNormalizer,
} from "../../../util/numericTransformation";

const styles = {} as React.CSSProperties;

export interface IWithdrawalRequestFormData extends WithdrawalRequestDto {}

interface IWithdrawalRequestFormProps {
    allAccountsList: { label: string; value: string }[];
    selectedAccountData: AccountDto;
}

type WithdrawalRequestPagePropsWithStyles = IWithdrawalRequestFormProps &
    InjectedFormProps<IWithdrawalRequestFormData, IWithdrawalRequestFormProps> &
    WithStyles;

const WithdrawalRequestForm: React.SFC<WithdrawalRequestPagePropsWithStyles> = (
    props
) => {
    const account = props.selectedAccountData;
    return (
        <Grid container>
            <Grid item xs={12}>
                <h4 className="hypodgrey" style={{ marginBottom: 0 }}>
                    Nosto suoritetaan vastatilillesi. Valitse tili, jolta haluat
                    tehdä nostopyynnön:{" "}
                </h4>
                <ExtendedField
                    component={renderSelectField}
                    name="accountNumber"
                    type="select"
                    placeholder=""
                    label="Tili"
                    required={true}
                    options={props.allAccountsList}
                />
            </Grid>

            <Grid item xs={6}>
                <ExtendedField
                    component={renderTextField}
                    name="amount"
                    type={"text"}
                    normalize={numericCommaStringNormalizer}
                    format={numericCommaStringFormatter}
                    placeholder=""
                    adornment="€"
                    multiline={false}
                    label={"Nostettava määrä"}
                    required={true}
                    inputProps={{ inputMode: "decimal" }}
                />
            </Grid>
            <Grid item xs={12}>
                <Typography>
                    Jos haluat tehdä omien tilien välisen siirron, niin ota
                    yhteyttä meihin viesti-toiminnolla.
                </Typography>
            </Grid>
            {/* <Grid item xs={12}>
        {
          props.selectedAccountData &&
          <h4 className="hypogrey">Vastatili:
            <span className="highlight">
              {account.contraAccount.accountName &&
                `${account.contraAccount.accountName} (${account.contraAccount.accountNumber})`
                || account.contraAccount.accountNumber && `#${account.contraAccount.accountNumber}`
              }
            </span>
          </h4>
        }
      </Grid> */}

            <Grid item xs={12}>
                <h4 className="hypodgrey" style={{ marginBottom: 0 }}>
                    Tarvittaessa otamme sinuun yhteyttä. Toivottu
                    yhteydenottotapa:{" "}
                </h4>
                <ExtendedField
                    component={renderCheckBox}
                    color="primary"
                    name="contactByEmail"
                    type="checkbox"
                    normalize={(v) => !!v}
                    label={"Sähköposti"}
                    required={true}
                />
                <ExtendedField
                    component={renderCheckBox}
                    color="primary"
                    name="contactByPhone"
                    type="checkbox"
                    normalize={(v) => !!v}
                    label={"Puhelin"}
                    required={true}
                />
            </Grid>
        </Grid>
    );
};

export default reduxForm<
    IWithdrawalRequestFormData,
    IWithdrawalRequestFormProps
>({
    validate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
})(withStyles(styles)(WithdrawalRequestForm));



// WEBPACK FOOTER //
// ./src/views/account/components/withdrawalRequestForm.tsx